// extracted by mini-css-extract-plugin
export default {"button":"Mk-z","reviewSort":"Nk-z"};